import nairaIcon from '../images/naira-icon.png'
const NairaIcon = () => {

    return (
        <img src={nairaIcon} alt="" style={{ width: "13px", marginBottom:"3px" }} />
    )
}
export default NairaIcon;